// Builds the PUT v2/seasons/... body for one season FROM ITS DETAIL
// (GET v2/seasons/..., which carries season.sensors).
//
// - active / archived: the season (V1's field projection) is parsed exactly as
//   V1 parses a field (GeneralClasses.Field), the changed values are applied the
//   way UpdateFieldModal's handlers apply them, buildFieldForSave runs as on V1
//   submit, and fieldManager.build_update_field_body produces the same body V1's
//   update_field PUTs. The server runs V1's update_field_logic on it.
// - template: only the changed keys (partial data), merged onto the template's
//   own crop_data / irrigation_system, and no sensors.
// GeneralClasses.Field parses detail.season.sensors with sensorFromJson, exactly
// as V1 parses field.sensors from GET /distribution, and build_update_field_body
// turns them back with sensorObjectsToDictionary — the same round trip as
// UpdateFieldModal. buildSeasonPutBody refuses a body that lost any sensor.
const GeneralClasses = require('GeneralClasses');
const fieldManager = require('fieldManager');
const { shouldWeekStartWithMonday } = require('farmingUnitManager');
const { buildFieldForSave } = require('../dashboard/field/editFieldSaveGuards');
const { buildSeasonPutBody, CROP_KEYS } = require('./seasonHelpers');

const firstDayOfWeekFor = (farmingUnit) => {
  if (!farmingUnit) {
    return 6;
  }
  return shouldWeekStartWithMonday(farmingUnit, null) ? 0 : 6;
};

const applyChange = (field, key, value) => {
  if (CROP_KEYS.includes(key)) {
    field.crop_data = { ...field.crop_data, [key]: value };
  } else if (key === 'irrigation_type') {
    field.irrigation_system = {
      ...field.irrigation_system,
      irrigation_type: value,
      recommendation_display: fieldManager.defaultRecommendationDisplay(value),
    };
  } else if (key === 'irrigation_rate') {
    field.irrigation_system = {
      ...field.irrigation_system,
      irrigation_rate: value,
    };
  } else if (key === 'expiration_date') {
    field.contract_data = { ...field.contract_data, expiration_date: value };
  } else {
    field[key] = value;
  }
};

const buildV1Body = (season, changes, farmingUnit) => {
  const field = new GeneralClasses.Field(
    JSON.parse(JSON.stringify(season)),
    season.id,
    firstDayOfWeekFor(farmingUnit),
  );
  Object.keys(changes).forEach((key) => applyChange(field, key, changes[key]));
  const forSave = buildFieldForSave({
    currentField: field,
    clusterId: field.cluster?.id ?? '',
    soilType: field.soil_type,
  });
  return fieldManager.build_update_field_body(forSave);
};

// farmingUnit: the V2 farming unit (only `country` is used, for the week start).
const buildSeasonSaveBody = (detailSeason, changes, farmingUnit) =>
  buildSeasonPutBody(detailSeason, changes, {
    buildV1Body: (season, seasonChanges) =>
      buildV1Body(season, seasonChanges, farmingUnit),
    defaultRecommendationDisplay: fieldManager.defaultRecommendationDisplay,
  });

module.exports = { buildSeasonSaveBody };
